import { Empty } from 'antd'
import { COMMENT_INDICATOR_GUTTER } from 'features/libra/comments/CommentIndicator'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const TopControls = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
`

export const LeftControls = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  flex: 1 1 13.75rem;
  min-width: min(13.75rem, 100%);
`

export const Label = styled.span`
  display: flex;
  align-items: center;
  min-width: 0;
  font-size: 0.8125rem;
  color: ${({ theme }) => theme.forecast.secondaryText};
  font-weight: 500;

  .ant-tag {
    margin-inline-start: 0.5rem;
    min-width: 0;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`

export const RightControls = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  flex: 0 1 auto;
  min-width: 0;
  max-width: 100%;
  justify-content: flex-end;
  margin-left: auto;
`

export const ZonesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const ZoneRowSurface = styled.div`
  cursor: pointer;
  scroll-margin-block: 1rem;
`

export const SourceDocumentLabel = styled.div`
  margin-top: 0.25rem;
  padding-left: 0.75rem;
  color: ${({ theme }) => theme.forecast.tertiaryText};
  font-size: 0.6875rem;
`

export const ZonesHeader = styled.h4`
  margin: 0 0 0.75rem;
  color: ${({ theme }) => theme.forecast.defaultText};
`

export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 1.5rem;
  background: ${({ theme }) => theme.forecast.background2};
  border-radius: 0.5rem;
  border: 1px solid ${({ theme }) => theme.forecast.border};
  margin-right: ${COMMENT_INDICATOR_GUTTER};
`

export const DrawingInstruction = styled(EmptyStateContainer)`
  padding: 1.5rem;
`

export const EmptyStateTitle = styled.div`
  font-size: 1rem;
  font-weight: 600;
  color: ${({ theme }) => theme.forecast.defaultText};
  margin-bottom: 0.5rem;
`

export const EmptyStateDescription = styled.div`
  font-size: 0.875rem;
  color: ${({ theme }) => theme.forecast.secondaryText};
  text-align: center;
  max-width: 25rem;
  margin-bottom: 1rem;
`

export const EmptyZoneList = styled(Empty)`
  padding: 1.5rem;
`
